import React from 'react';
interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
}
export function Switch({
  checked,
  onChange,
  label
}: SwitchProps) {
  return <button type="button" role="switch" aria-checked={checked} aria-label={label} onClick={() => onChange(!checked)} className={`relative h-[26px] w-[46px] shrink-0 rounded-pill border transition-colors duration-150 ease-brand ${checked ? 'border-gold bg-gold' : 'border-sand-line bg-sand-deep'}`} data-id="element-1254" data-mp="2dslmrhcwoaue">
      <span className={`absolute top-[2px] h-[20px] w-[20px] rounded-pill bg-white transition-[left] duration-150 ease-brand ${checked ? 'left-[23px]' : 'left-[2px]'}`} aria-hidden="true" data-id="element-1255" data-mp="3bfkk7ubf9mtc" />
    </button>;
}